<template>
  <div class="prestitial-cookie" style="display: none;" />
</template>
<script>
import cookies from 'js-cookie';

export default {
  props: {
    cookieName: {
      type: String,
      required: true,
    },
    cookieValue: {
      type: String,
      default: '0',
    },
    expires: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    adHeight: 500,
    adWidth: 500,
    prestitialDuration: 15,
    prestitialCounter: null,
  }),
  created() {
    cookies.set(this.cookieName, this.cookieValue, { expires: this.expires });
    this.updateAd();
    const elements = document.querySelectorAll('.hideOverlayLink');
    elements.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        this.hideOverlay();
      });
    });
  },
  beforeDestroy() {
    const elements = document.querySelectorAll('.hideOverlayLink');
    elements.forEach((element) => {
      element.removeListener('click', (e) => {
        e.preventDefault();
        this.hideOverlay();
      });
    });
  },
  methods: {
    hideOverlay() {
      clearInterval(this.prestitialCounter);
      const wrapper = document.getElementById('overlayWrapper');
      if (wrapper) {
        wrapper.parentNode.removeChild(wrapper);
      }
    },
    timer() {
      this.prestitialDuration -= 1;
      if (this.prestitialDuration <= 0) {
        this.hideOverlay();
        return;
      }
      document.getElementById('prestitialSeconds').innerHTML = this.prestitialDuration;
    },
    updateAd() {
      // eslint-disable-next-line no-use-before-define
      this.prestitialCounter = setInterval(this.timer, 1000);
      // let prestitialCounter = 0;
      document.getElementById('prestitialSeconds').innerHTML = this.prestitialDuration;
    },
  },
};
</script>
